export default function BarChartLabel({ x, y, width, value }) {
  if (value === 0 || value == null) return null;

  return (
    <text
      x={x + width / 2}
      y={y - 8}
      textAnchor="middle"
      fontSize="12"
      fill="var(--q3-neutral-default)"
      fontWeight="bold"
    >
      {Math.round(value)}
    </text>
  );
}
